var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "a",
        {
          directives: [{ name: "b-tooltip", rawName: "v-b-tooltip" }],
          class: ["action", { loading: _vm.removing }],
          attrs: { href: "#", title: _vm.title },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.onClick.apply(null, arguments)
            }
          }
        },
        [
          _c("Icon", {
            attrs: {
              icon: _vm.exclusionType !== null ? "plus-circle" : "minus-circle"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.showRemovePopUp
        ? _c(
            "PopUp",
            {
              attrs: { title: "Job wieder anzeigen", "ok-text": "OK" },
              on: {
                ok: _vm.removeExclusion,
                hidden: function($event) {
                  _vm.showRemovePopUp = false
                }
              }
            },
            [_vm._v("\n\t\tJob wieder in der Matchingliste anzeigen?\n\t")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }